import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'

import './styles.sass'

const baseClass = 'wb-badge'

export const Badge = ({ variant, ...passThroughProps }) => {
  return (
    <div
      {...passThroughProps}
      className={cn(baseClass, {
        [`${baseClass}--default`]: !variant || variant === 'default',
        [`${baseClass}--error`]: variant === 'error',
        [`${baseClass}--warning`]: variant === 'warning',
        [`${baseClass}--success`]: variant === 'success'
      })}
    />
  )
}

Badge.Proptypes = {
  variant: PropTypes.oneOf(['default', 'success', 'error', 'warning'])
}
